// features/search/api.ts — typed fetch for the header ⌘K search.
//
// POSTs to /v2/search. Companies-only — Postgres-only matches on
// company_name / cnpj / tickers[]. The backend ranks by match
// quality and caps the response at 200 rows; `meta.total` carries
// the un-truncated count for the "(N resultados)" copy when the
// cap bites.
import { apiRequest } from "@/lib/api-client";

export interface SearchCompanyRow {
  cnpj: string;
  company_name: string | null;
  tickers: string[];
  info: Record<string, unknown>;
  created_at: string;
  updated_at: string;
}

export interface SearchMeta {
  q: string;
  /** Rows actually returned in this response (≤ 200). */
  company_count: number;
  /** Total matching rows before the 200-row cap. */
  total: number;
  /** `true` when `total > company_count` — the palette copy uses this. */
  truncated: boolean;
  source: string;
  generated_at?: string;
  cached?: boolean;
}

export interface SearchResponse {
  companies: SearchCompanyRow[];
  meta: SearchMeta;
}

export function searchAll(
  q: string,
  opts: {
    signal?: AbortSignal;
  } = {},
): Promise<SearchResponse> {
  return apiRequest<SearchResponse>("/v2/search", {
    method: "POST",
    body: { q },
    signal: opts.signal,
  });
}
